import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { eDiemDanhTrangThaiActionTypeIds, IDiemDanhTrangThaiDeleteStart, IDiemDanhTrangThaiSaveStart } from "../../action-types/danh-muc/IDiemDanhTrangThaiActionTypes";
import { actions } from "../../actions/actionsWrapper";

const diemDanhTrangThaiApi = apiWrapper.diemDanhStatus;

export function* diemDanhTrangThaiSaga(): any {
    yield takeLatest(eDiemDanhTrangThaiActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eDiemDanhTrangThaiActionTypeIds.DELETE_START, deleteWorker)
    yield takeEvery(eDiemDanhTrangThaiActionTypeIds.SAVE_START, saveWorker)
}
function* loadWorker(): any {

    const res: IBaseResponeModel = yield call([diemDanhTrangThaiApi, diemDanhTrangThaiApi.SelectAll])
    if (res.is_success) {
        yield put(actions.danhMucWrapper.trangThai.loadSuccess(res.data))
    } else {
        yield put(actions.danhMucWrapper.trangThai.loadError(res.message || "Không tải được tuần"))
    }
}
function* deleteWorker(action: IDiemDanhTrangThaiDeleteStart): any {
    const res: IBaseResponeModel = yield call([diemDanhTrangThaiApi, diemDanhTrangThaiApi.DeleteMultiple], action.payload)
    if (res.is_success) {
        yield put(actions.danhMucWrapper.trangThai.deleteSuccess())
    } else {
        yield put(actions.danhMucWrapper.trangThai.deleteError(res.message || "Không xóa được tuần"))
    }
}

function* saveWorker(action: IDiemDanhTrangThaiSaveStart): any {
    let res: IBaseResponeModel;
    if (action.payload.id > 0) {
        res = yield call([diemDanhTrangThaiApi, diemDanhTrangThaiApi.Update], action.payload);
    } else {
        res = yield call([diemDanhTrangThaiApi, diemDanhTrangThaiApi.Insert], action.payload);
    }
    if (res.is_success) {
        yield put(actions.danhMucWrapper.trangThai.saveSuccess())
        yield put(actions.danhMucWrapper.trangThai.loadStart())
    } else {
        yield put(actions.danhMucWrapper.trangThai.saveError(res.message || "Không lưu được tiết học"))
    }
}